__turbopack_context__.v({
  "className": "newsreader_f506abf6-module__XcdFia__className",
});
